export default "__VITE_ASSET__DP0dEKla__"